export default __webpack_public_path__ + "static/k3-355a3bdd732f7bec3f524a5b4072282d.jpg";